// Lightweight, framework-agnostic server status tracker.
// Used to detect when the backend server is down/unreachable and to
// show a global "server down / maintenance" screen across the app.

let isDown = false;
const listeners = new Set();

export const getServerDown = () => isDown;

export const setServerDown = (value) => {
  const next = Boolean(value);
  if (isDown !== next) {
    isDown = next;
    listeners.forEach((listener) => {
      try {
        listener(next);
      } catch (e) {
        // ignore listener errors
      }
    });
  }
};

export const subscribeServerStatus = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Decide whether an axios/fetch error means the *server* is down
// (as opposed to a normal 4xx business error).
export const isServerDownError = (error) => {
  if (!error) return false;

  // axios timeout
  if (error.code === "ECONNABORTED") return true;
  // generic network failure (no connection / server unreachable)
  if (error.message === "Network Error") return true;
  // request was made but no response received
  if (error.request && !error.response) return true;

  const status = error.response?.status;
  // gateway / service unavailable / timeout from proxy
  return status === 502 || status === 503 || status === 504;
};
